export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_12.87930f8c.jpg";